import { Button, BUTTON_TYPES } from '../../../components/Button'
import { FieldWithLabel } from '../../../components/FieldWithLabel/FieldWithLabel'
import { BTN_TXT } from '../../../constants'
import { ReactComponent as Plus16 } from '../../../assets/svg/Plus16.svg'
import { ReactComponent as Edit16 } from '../../../assets/svg/Edit16.svg'
import { useContractDetailsPopup } from '../Providers/ContractDetailsPopupProvider'
import { Note } from './Note'
import cn from 'classnames'
import { TNote } from '../types'

type ViewNoteButtonProps = {
  canViewNote: boolean
  canEditNote: boolean
  title: string
  note: TNote | null
}

export const ViewNoteButton = ({
  canViewNote,
  canEditNote,
  title,
  note
}: ViewNoteButtonProps) => {
  const { addNotePopup } = useContractDetailsPopup()

  if (!(canEditNote || canViewNote) && !note) return null

  return canViewNote ? (
    <FieldWithLabel
      title={
        <div className="row gap-8 align-center">
          <span>{title}</span>
          {canEditNote && note && (
            <Button
              type={BUTTON_TYPES.GHOST}
              icon={<Edit16 className="attachment__icon" />}
              onClick={() => addNotePopup.actions.open()}
              medium
              upperCase
            />
          )}
        </div>
      }
      className={cn({
        'full-row': note?.text
      })}
    >
      {note ? (
        <Note note={note} />
      ) : canEditNote ? (
        <Button
          type={BUTTON_TYPES.GHOST}
          icon={<Plus16 className="attachment__icon" />}
          onClick={() => addNotePopup.actions.open()}
          medium
          upperCase
        >
          {BTN_TXT.ADD_NOTE}
        </Button>
      ) : (
        '-'
      )}
    </FieldWithLabel>
  ) : null
}
